// /UI/Dropzone/utils/constants.js

// File upload limits
export const VIDEO_LIMIT = 3;
export const MAX_SIZE_BYTES = process.env.REACT_APP_DROPZONE_MAX_SIZE || 104857600; // 100MB default
export const MAX_RETRIES = 3;

// Upload status states
export const UPLOAD_STATUS = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  COMPLETED: 'completed',
  PARTIAL: 'partial',
  FAILED: 'failed',
};

// Accepted file types for dropzone
export const ACCEPTED_FILE_TYPES = {
  'image/*': [],
  'video/*': [],
};

// Animation variants for framer-motion
export const ANIMATIONS = {
  containerVariants: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
  },
  itemVariants: {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
    exit: { x: -20, opacity: 0, transition: { duration: 0.2 } },
  },
};

// Notification auto-dismiss time in ms
export const NOTIFICATION_DURATION = 5000;
